export default "__VITE_ASSET__C87RwKev__"